const requireModule = require.context('.', false, /\.vue$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\.vue)/g, '')
  modules[moduleName] = requireModule(fileName).default
})

export default modules
